import { IonButton, IonButtons, IonItem, IonProgressBar } from '@ionic/react';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';

import { WizardSteps } from '../../components/CreateGroupPage';
import PersonalizeGroupForm from '../../components/forms/PersonalizeGroupForm';
import Heading from '../../components/Heading';
import Paragraph from '../../components/Paragraph';
import { JSONApi } from '../../types';

type Props = {
  group: JSONApi.GroupResource;
};

const SetupGroupPersonalization = ({ group }: Props) => {
  const history = useHistory();

  const handleBackClick = useCallback(() => {
    history.push({ pathname: `/create/${group.attributes.slug}/${WizardSteps.NAMES}` });
  }, [group.attributes.slug, history]);

  const handleNextClick = useCallback(() => {
    history.push({ pathname: `/create/${group.attributes.slug}/${WizardSteps.VERIFICATION}` });
  }, [group.attributes.slug, history]);

  return (
    <div className="setup-group-personalization-form">
      <IonProgressBar buffer={0.2} color="success" value={0} />
      <Heading level={2}>
        <FormattedMessage id="pages.groupWizard.personalization.title" />
      </Heading>
      <Paragraph>
        <FormattedMessage id="pages.groupWizard.personalization.description" />
      </Paragraph>
      <PersonalizeGroupForm group={group} />
      <IonItem color="transparent" lines="none">
        <IonButtons slot="end">
          <IonButton color="primary" fill="outline" onClick={handleBackClick} size="default">
            <FormattedMessage id="dictionary.previous" />
          </IonButton>
          <IonButton color="primary" fill="solid" onClick={handleNextClick} size="default">
            <FormattedMessage id="dictionary.next" />
          </IonButton>
        </IonButtons>
      </IonItem>
    </div>
  );
};

export default SetupGroupPersonalization;
